var _a;
import { IconButton } from "@material-ui/core";
import { CloseOutlined } from "@material-ui/icons";
import React from "react";
import { connect, useDispatch } from "react-redux";
import { resetAnnouncementLatestInfo } from "../../store/announcement/actions";
import { announcementLatestData } from "../../store/announcement/reducer";
import { LAST_SEEN_ANNOUNCEMENT, storeItem, } from "../../utils/LocalStorageUtil";
import "./announcement.scss";
var EContext;
(function (EContext) {
    EContext["Success"] = "SUCCESS";
    EContext["Info"] = "INFO";
    EContext["Warning"] = "WARNING";
    EContext["Danger"] = "DANGER";
})(EContext || (EContext = {}));
var ANNOUNCEMENT_CLASS = (_a = {},
    _a[EContext.Success] = "announcement__success",
    _a[EContext.Info] = "announcement__info",
    _a[EContext.Warning] = "announcement__warning",
    _a[EContext.Danger] = "announcement__danger",
    _a);
export var Announcement = function (_a) {
    var announcementLatestData = _a.announcementLatestData;
    var dispatch = useDispatch();
    var getClassByType = function (type) {
        if (type && Object.keys(ANNOUNCEMENT_CLASS).includes(type)) {
            return ANNOUNCEMENT_CLASS[type];
        }
        return "";
    };
    var handleClose = function () {
        storeItem(LAST_SEEN_ANNOUNCEMENT, announcementLatestData === null || announcementLatestData === void 0 ? void 0 : announcementLatestData.updatedDate);
        dispatch(resetAnnouncementLatestInfo());
    };
    return announcementLatestData ? (React.createElement("div", { className: "announcement" },
        React.createElement("div", { className: "announcement__content " + ((announcementLatestData === null || announcementLatestData === void 0 ? void 0 : announcementLatestData.context) &&
                getClassByType(announcementLatestData === null || announcementLatestData === void 0 ? void 0 : announcementLatestData.context)) },
            React.createElement("div", { className: "content__title" },
                React.createElement("p", { className: "content__title__label" }, (announcementLatestData === null || announcementLatestData === void 0 ? void 0 : announcementLatestData.title) || "-"),
                React.createElement("div", { className: "content__title__btn" },
                    React.createElement(IconButton, { onClick: handleClose, size: "small" },
                        React.createElement(CloseOutlined, { fontSize: "small" })))),
            React.createElement("p", { className: "content__message" }, (announcementLatestData === null || announcementLatestData === void 0 ? void 0 : announcementLatestData.content) || "-")))) : null;
};
function mapStateToProps(state) {
    return { announcementLatestData: announcementLatestData(state) };
}
export default connect(mapStateToProps)(Announcement);
